import React, { useCallback } from 'react'
import { TABLE_NAME } from 'src/app/shared/constants/tableName.constants'
import { useFileMappingByClient } from './useFileMappingByClient'
import { Layout } from 'antd'
import { getListFileMappingFormatsByClients } from 'src/app/shared/services/ClientSetupService'
import { EPermissions, ESubModules } from 'src/app/shared/models/roleAndPermission.model'
import { useRolePermission } from 'src/app/shared/hooks/useRolePermission'
import { FORMAT_TYPE_VALUE } from 'src/app/shared/constants/app.constants'
import NewCommonTable from 'src/app/shared/components/common/new-table'
import { IGetExportData } from 'src/app/shared/components/common/new-table/table-setting.model'
import { TableColumnDefs } from 'src/app/shared/components/common/new-table/table.model'
import { settingHeightTableWithFilter } from 'src/app/shared/constants/common.constants'

const FileMappingByClientTabContent: React.FC = () => {
  const { fileMappingByClient, isGettingFileMappingByClient, getFileMappingByClientList } = useFileMappingByClient()
  const { userPermissions } = useRolePermission()

  const handleSearch = useCallback(
    async (value: Partial<IGetExportData>) => {
      await getFileMappingByClientList(value)
    },
    [getFileMappingByClientList],
  )

  const generateCustomColumnDefs = useCallback((colDefs: Array<TableColumnDefs>): Array<TableColumnDefs> => {
    const defs = colDefs.map((item, index) => {
      if (item.colId === 'formatType') {
        item.cellRenderer = (row: any) => {
          return (
            <>
              {['csv', 'excel'].includes(row?.data['formatType'])
                ? FORMAT_TYPE_VALUE[row?.data['formatType']]
                : row?.data['formatType']}
            </>
          )
        }
      }

      return item
    })
    return defs
  }, [])

  return (
    <Layout.Content>
      <NewCommonTable
        rowData={fileMappingByClient?.items}
        total={fileMappingByClient?.total}
        displayAddBtn={false}
        displayUploadButton={false}
        displayActionColumn={false}
        displayDownloadBtn={userPermissions[ESubModules.FIL_MAP_SET]?.includes(EPermissions.DOWNLOAD)}
        loading={isGettingFileMappingByClient}
        translationNamespace='FileMappingSetup:file_mapping_by_clients'
        pageName={TABLE_NAME.FILE_MAPPING_FORMAT_BY_CLIENT}
        tableSettingName={TABLE_NAME.FILE_MAPPING_FORMAT_BY_CLIENT}
        handleSearch={handleSearch}
        handleDownload={async (payload) => await getListFileMappingFormatsByClients(payload)}
        generateCustomColumnDefs={generateCustomColumnDefs}
        settingHeightTable={settingHeightTableWithFilter}
      />
    </Layout.Content>
  )
}

export default FileMappingByClientTabContent
